import { render, staticRenderFns } from "./productimage.vue?vue&type=template&id=4b58de34&"
import script from "./productimage.vue?vue&type=script&lang=js&"
export * from "./productimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports